// custom pages
import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const leaveTypeAPI = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getLeaveTypesAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(`${config.host}/panel/leave-type/findAll`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getLeaveTypeCreateAPI(data) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      let res = await fetch(`${config.host}/panel/leave-type/create`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getLeaveTypesAPI,
    getLeaveTypeCreateAPI,
  };
};

export default leaveTypeAPI;
